import React from 'react';
import { observer } from 'mobx-react';
import { Plate } from '@alfa-retail-react/components';
import classNames from 'classnames';

import { useIsDesktop } from 'app/utils/useWindowType';
import { InsuranceDetails } from 'app/logic/pages/productParametersConfigure/InsuranceDetails';
import { InsuranceChoiceFormItem } from 'app/logic/pages/productParametersConfigure/InsuranceChoiceFormItem';
import { FormatUtils } from 'app/utils/FormatUtils';
import { Section } from 'app/component/Section';
import { TransparentCover } from 'app/component/TransparentCover';
import { InsuranceToggleFormItem } from 'app/logic/pages/productParametersConfigure/InsuranceToggleFormItem';
import { ProductParametersConfigurePageStore } from 'app/logic/pages/productParametersConfigure/ProductParametersConfigurePageStore';
import { useI18nContext } from 'app/store/сontext/I18nContext';

export interface InsuranceFormProps {
    pageStore: ProductParametersConfigurePageStore;
}

/**
 * Форма выбора страхового продукта.
 */
export const InsuranceForm = observer(({ pageStore }: InsuranceFormProps) => {
    const { formStore } = pageStore;
    const { insuranceStore } = formStore;
    const [isDesktop] = useIsDesktop();
    const { t } = useI18nContext();

    const titleCode = isDesktop
        ? 'redCard_terms_insuranceBlock_title_desktop'
        : 'redCard_terms_insuranceBlock_title';
    const title = t(titleCode);
    const choiceItemTitle = t('redCard_terms_insuranceBlock_title');

    const threshold = FormatUtils.toIntegerString(
        insuranceStore.minInsuranceCreditAmount,
    );

    const insuranceInfoLabelCode = formStore.hasAppliedInsurance
        ? 'redCard_terms_insuranceInfo_on'
        : 'redCard_terms_insuranceInfo_off';

    return (
        <>
            <Section
                className={'insuranceFormSection'}
                title={title}
                content={
                    <>
                        {isDesktop && (
                            <div className="sectionInfo">
                                {t('redCard_terms_insuranceBlock_description')}
                            </div>
                        )}
                        <InsuranceDetails threshold={threshold} />
                        {!formStore.hasAvailableInsurance && (
                            <Plate
                                className={'hasNoAvailableInsuranceMessage'}
                                view={'attention'}
                            >
                                Страховка будет доступна от {threshold}
                            </Plate>
                        )}
                        <TransparentCover
                            disabled={!formStore.hasAvailableInsurance}
                        >
                            <InsuranceToggleFormItem
                                formStore={formStore}
                                title={choiceItemTitle}
                            />
                            {formStore.hasAppliedInsurance && (
                                <>
                                    {formStore.displayInsuranceList?.length >
                                        1 && (
                                        <h3 className="insuranceAdvantagesTitle">
                                            Выберите страховой взнос
                                        </h3>
                                    )}
                                    <InsuranceChoiceFormItem
                                        downloadInsuranceInstructions={
                                            pageStore.downloadInsuranceInstructions
                                        }
                                        formStore={formStore}
                                    />
                                </>
                            )}
                            <section className="plateSection">
                                <Plate
                                    view="neutral"
                                    contentClassName={classNames(
                                        'plateContent',
                                        {
                                            minified:
                                                !formStore.hasAppliedInsurance,
                                        },
                                    )}
                                >
                                    {t(insuranceInfoLabelCode)}
                                </Plate>
                            </section>
                        </TransparentCover>
                    </>
                }
            />
        </>
    );
});
